import React from 'react';
import logo from '../assets/Images/wglogo.svg'
import { Link } from 'react-router-dom';
// import { Button } from "@material-tailwind/react";

const PrimaryButton = (props) => {
    const classes = "primary"
    const combinedClasses = `${classes} ${props.className}`;
    return (

        <button className={combinedClasses} role="button">{props.text}</button>



    );

}

export default PrimaryButton;